import { Component, computed, input } from '@angular/core';
import {
  FeaturedIconColor,
  FeaturedIconSize,
  FeaturedIconTheme,
} from './featured-icon.types';

@Component({
  selector: 'ntt-featured-icon',
  templateUrl: './featured-icon.html',
  styleUrl: './featured-icon.scss',
  host: {
    '[class]': 'hostClasses()',
  },
})
export class NttFeaturedIcon {
  readonly size = input<FeaturedIconSize>('md');
  readonly color = input<FeaturedIconColor>('brand');
  readonly theme = input<FeaturedIconTheme>('outline');
  readonly icon = input<string>('icon-alert-circle');

  protected readonly hostClasses = computed(() => {
    const sizeClass = `ntt-featured-icon--size-${this.size()}`;
    const colorClass = `ntt-featured-icon--color-${this.color()}`;
    const themeClass = `ntt-featured-icon--theme-${this.theme()}`;
    return `ntt-featured-icon ${sizeClass} ${colorClass} ${themeClass}`;
  });
}
